"use client";

import { useState } from "react";
import type { IntentionId } from "./content";
import { trackLandingEvent } from "./analytics";
import { IntentionThread } from "./IntentionThread";
import { HeroTwoLives, IntentionSelector } from "./HeroAndIntention";
import { BeyondThePhoto, CompatibilityExperience, EncounterDemo } from "./DiscoverySections";
import { ComparisonExperience, ConversationDemo, DownloadFinale, RealLifeJourney, TrustAndVerification, WaysToMeet } from "./ClosingSections";
import { RELEASE_FEATURES } from "../../lib/releaseFeatures";

export function LandingExperience() {
  const [intention, setIntention] = useState<IntentionId | null>(null);
  const choose = (id: IntentionId) => { setIntention(id); trackLandingEvent("intention_option_selected"); };
  return <div className="landing-page"><IntentionThread /><HeroTwoLives /><IntentionSelector selected={intention} onSelect={choose} /><BeyondThePhoto /><CompatibilityExperience onComplete={() => undefined} /><EncounterDemo onMatch={() => trackLandingEvent("encounter_match_completed")} sound={false} /><ConversationDemo /><RealLifeJourney />{RELEASE_FEATURES.socialEvents ? <WaysToMeet /> : null}<ComparisonExperience /><TrustAndVerification /><DownloadFinale intention={intention} /></div>;
}
